import { apiCall } from './base'
import { API_AUTH_URL, FACEBOOK_CALLBACK, GOOGLE_CALLBACK } from '../config'

export const signin = async (data) => {
  const result = await apiCall('/api/v1/auth/', {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data
  })
  return result
}

export const signinPhone = async (data) => {
  const result = await apiCall('/api/v1/auth/sendpin', {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data
  })
  return result
}

export const signinFacebook = async () => {
  const result = await apiCall(
    `api/v1/auth/social/facebook?redirect_url=${FACEBOOK_CALLBACK}`,
    {
      baseURL: API_AUTH_URL,
      method: 'GET',
      withCredentials: true,
      immediately: true
    }
  )
  return result
}

export const signinGoogle = async () => {
  const result = await apiCall(
    `api/v1/auth/social/google?redirect_url=${GOOGLE_CALLBACK}`,
    {
      baseURL: API_AUTH_URL,
      method: 'GET',
      withCredentials: true,
      immediately: true
    }
  )
  return result
}

export const getTokenFromSocialCode = async (code, redirect_url, provider) => {
  const data = {
    code,
    redirect_url,
    provider
  }
  const result = await apiCall(`api/v1/auth/social/${provider}/callback`, {
    baseURL: API_AUTH_URL,
    method: 'GET',
    withCredentials: true,
    immediately: true,
    params: data
  })
  return result
}

export const acceptTerms = (data) =>
  apiCall('/api/v1/auth/accept-terms', {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    params: {},
    data
  })

export const refreshToken = (data) =>
  apiCall('api/v1/auth/refresh-token', {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    params: {},
    data
  })

export const acceptSowrnStatement = (data) =>
  apiCall('/api/v1/auth/accept-sworn-statement', {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    params: {},
    data
  })


export const loginOTP = async (token) => {
  const result = await apiCall(`/api/v1/auth/token?otp=${token}`, {
    baseURL: API_AUTH_URL,
    method: 'GET',
    withCredentials: true,
    immediately: true
  })
  return result
}


